import { render, staticRenderFns } from "./topNotice.vue?vue&type=template&id=42cb0544&scoped=true"
import script from "./topNotice.vue?vue&type=script&lang=js"
export * from "./topNotice.vue?vue&type=script&lang=js"
import style0 from "./topNotice.vue?vue&type=style&index=0&id=42cb0544&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cb0544",
  null
  
)

export default component.exports